export const IMAGE_MAPPING = {
  'http://static.smartshell.gg/backgrounds_default/1.png':
    '/images/Customization/customization_default1.webp',
  'http://static.smartshell.gg/backgrounds_default/2.png':
    '/images/Customization/customization_default2.webp',
  'http://static.smartshell.gg/backgrounds_default/3.png':
    '/images/Customization/customization_default3.webp',
  'http://static.smartshell.gg/backgrounds_default/4.png':
    '/images/Customization/customization_default4.webp',
  'http://static.smartshell.gg/backgrounds_default/5.png':
    '/images/Customization/customization_default5.webp',
  'http://static.smartshell.gg/backgrounds_default/6.png':
    '/images/Customization/customization_default6.webp',
  'http://static.smartshell.gg/backgrounds_default/8.png':
    '/images/Customization/customization_default8.webp',
} as const;

export const IMAGES_LINKS = Object.keys(IMAGE_MAPPING) as Array<
  keyof typeof IMAGE_MAPPING
>;
